
import { useEffect, useState } from 'react'
import CtaButton from '../../components/ctaButton/CtaButton'
import './style.scss'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { ChatInteractions } from '../../server/types'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { InteractionStatus } from '../../types/types'
import { getBookingStatusLabel } from '../../utils/RetrieveStrings'
import ProfileIcon from '../../components/profileIcon/ProfileIcon'

// type DashboardLeaderboard = {
// 	instructorImgSrc: string
// 	instructorName: string
// 	instructorLevel: string
// 	bookingType: 'ski' | 'snowboard'
// 	bookingId: string
// 	// lastUpdateTime: string
// }

function DashboardInstructorContentArea() {
	const [interactios, setInteractions] = useState<ChatInteractions[]>([])
	const [bookingDetails, setBookingDetails] = useState<ChatInteractions[]>([])
	// const [leaderboard, setLeaderboard] = useState<DashboardLeaderboard[]>([])
	const [userDataLoaded, setUserDataLoaded] = useState<boolean>(false)
	const [totalEarnings, setTotalEarnings] = useState<string>('0.00')

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	// Setup test values
	useEffect(() => {
		// setTimeout(() => loadProfileData(), 200)
		if (dataLoadRequestFinished === true) {
			setBookingDetails(userStateData.getInteractions())
			const interactions: ChatInteractions[] = userStateData.getInteractions()
			let activeInteractions: ChatInteractions[] = []
			let completeCount: number = 0
			let earnings: number = 0
			// let totalEarnings: number = 0
			interactions.forEach((interaction: ChatInteractions) => {
				if (interaction.status === InteractionStatus.PAYMENT_IN_PROGRESS || interaction.status === InteractionStatus.PAYMENT_FAILED) {
				}
				else {
					// earnings += parseFloat(interaction.price ? interaction.price : '0')
					if (interaction.status === InteractionStatus.ACTIVE) { // || interaction.status === InteractionStatus.REVIEW) {
						activeInteractions.push(interaction)
					} else if (interaction.status === InteractionStatus.COMPLETE) {
						completeCount += 1
						earnings += parseFloat(interaction.price ? interaction.price : '0') * 0.0055
						if (interaction.tip_payment_status == 'PAYMENT_COMPLETE') {
							earnings += parseFloat(interaction.tip_price ? interaction.tip_price : '0') / 100
						}
					}
				}
			})

			setTotalEarnings(earnings.toFixed(2))
			
			if (completeCount > 0) {
				const iconUrl: string | undefined = userStateData.getUserIconUrl()
				// setLeaderboard([{
				// 	instructorImgSrc: iconUrl ? iconUrl : '',
				// 	instructorName: userStateData.getUsersName(),
				// 	instructorLevel: userStateData.getLevel(),
				// 	bookingType: 'ski',
				// 	bookingId: '1'
				// },{
				// 	instructorImgSrc: '/uploads/profile_pics/profile-m-00001.png',
				// 	instructorName: "Brayan Hanna",
				// 	instructorLevel: '2',
				// 	bookingType: 'ski',
				// 	bookingId: '1'
				// },{
				// 	instructorImgSrc: '/uploads/profile_pics/profile-m-00005.png',
				// 	instructorName: "Cynthia Abbott",
				// 	instructorLevel: '2',
				// 	bookingType: 'ski',
				// 	bookingId: '1'
				// }])
				// setTotalEarnings(`${completeCount * 25}.00`)
			} else {
				// setLeaderboard([{
				// 	instructorImgSrc: '/uploads/profile_pics/profile-m-00001.png',
				// 	instructorName: "Brayan Hanna",
				// 	instructorLevel: '2',
				// 	bookingType: 'ski',
				// 	bookingId: '1'
				// },{
				// 	instructorImgSrc: '/uploads/profile_pics/profile-m-00005.png',
				// 	instructorName: "Cynthia Abbott",
				// 	instructorLevel: '2',
				// 	bookingType: 'ski',
				// 	bookingId: '1'
				// },{
				// 	instructorImgSrc: '/uploads/profile_pics/profile-f-00001.png',
				// 	instructorName: "Other Tester",
				// 	instructorLevel: '3',
				// 	bookingType: 'ski',
				// 	bookingId: '1'
				// }])
			}
			setInteractions(activeInteractions)
			setUserDataLoaded(true)
			// setBookingDetails([])
		}
	}, [dataLoadRequestFinished])

	return (
		<div className='dashboard-content-area-wrap'>
			<div className='dashboard-content-area-small-card-wrap'>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-chat.svg`}
							alt='Chat symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Chats</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{
						// chats.length === 0 ?
						interactios.length === 0 ?
							<span>No ongoing chats</span>
							:
							// chats.map((chat: DashboardChat, index: number) => 
							interactios.map((interactios: ChatInteractions, index: number) => 
								<a 
									className='dashboard-content-area-card-chat-wrap'
									key={`chatItem${index}`}
									href={`chat?id=${interactios.id}`}
								>
									<img
										className='dashboard-content-area-card-chat-img'
										alt='profile thumbnail'
										src={interactios.otherUserDetails?.profile_pics ? getProfilePicPath(interactios.otherUserDetails?.profile_pics, 0) : undefined}
									/>
									<div className='dashboard-content-area-card-chat-details-wrap'>
										<div className='dashboard-content-area-card-chat-name'>{interactios.otherUserDetails?.name}</div>
										<div className='dashboard-content-area-card-chat-extract'>...</div>
									</div>
								</a>
							)
						}
					</div>
					{/* <div
						className='dashboard-content-area-card-bottom-wrap'
					>
						<CtaButton
							label='View All Chats'
							size='large'
							onClick={() => console.log('View All Chats clicked')}
						/>
					</div> */}
				</div>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-profile.svg`}
							alt='Profile symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Profile</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{userDataLoaded ? 
							<>
								<div className='dashboard-content-area-card-profile-name-wrap'>
									<ProfileIcon
										imgSrc={userStateData.getUserIconUrl()}
									/>
									<div className='dashboard-content-area-card-profile-name'>{userStateData.getUsersName()}</div>
								</div>
								<div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Status</div>
									{userStateData.getStatusMessage()}
								</div>
								<div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Age</div>
									{userStateData.getAge()}
								</div>
								<div className='dashboard-content-area-card-profile-details dashboard-content-area-card-profile-details-extra-base'>
									<div className='dashboard-content-area-card-profile-details-label'>Language</div>
									English
								</div>
								<div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Phone</div>
									{userStateData.getPhoneNumber()}
								</div>
								<div className='dashboard-content-area-card-profile-details dashboard-content-area-card-profile-details-extra-base'>
									<div className='dashboard-content-area-card-profile-details-label'>Email</div>
									{userStateData.getEmail()}
								</div>
								{/* <div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Card Details</div>
									**** **** **** 1234
								</div> */}
							</>:<>Loading...</>
						}
					</div>
					<div
						className='dashboard-content-area-card-bottom-wrap'
					>
						<CtaButton
							label='View Profile'
							size='large'
							onClick={() => window.location.replace(PAGE_URLS.DASHBOARD_PROFILE)}
						/>
					</div>
				</div>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-earnings.svg`}
							alt='Earnings'
						/>
						<div className='dashboard-content-area-card-title-label'>Earnings</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{/* <div className='dashboard-content-area-earnings-title'>Total Earnings</div> */}
						<div className='dashboard-content-area-card-earnings-wrap'>
							<div className='dashboard-content-area-card-earnings-title'>Total Earnings</div>
							<div className='dashboard-content-area-card-earnings-value'>${totalEarnings}</div>
						</div>
						<div className='dashboard-content-area-card-earnings-wrap'>
							<div className='dashboard-content-area-card-earnings-title'>Last Week Earnings</div>
							<div className='dashboard-content-area-card-earnings-value'>${totalEarnings}</div>
						</div>
						<div className='dashboard-content-area-card-earnings-wrap'>
							<div className='dashboard-content-area-card-earnings-title'>Last Month Earnings</div>
							<div className='dashboard-content-area-card-earnings-value'>${totalEarnings}</div>
						</div>
					</div>
					<div
						className='dashboard-content-area-card-bottom-wrap'
					>
						<CtaButton
							label='View Details'
							size='large'
							onClick={() => { window.location.replace(PAGE_URLS.DASHBOARD_EARNINGS) }}
						/>
					</div>
				</div>
			</div>
			<div className='dashboard-content-area-wide-card-wrap'>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-booking.svg`}
							alt='Booking symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Booking Details</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{bookingDetails.length === 0 ?
							<span>No Bookings</span>
							:
							bookingDetails.map((booking: ChatInteractions, index: number) => 
								<a 
									className='dashboard-content-area-card-chat-wrap'
									key={`chatItem${index}`}
									href={`chat?id=${booking.id}`}
								>
									<img
										className='dashboard-content-area-card-chat-img'
										alt='profile thumbnail'
										src={booking.otherUserDetails?.profile_pics ? getProfilePicPath(booking.otherUserDetails?.profile_pics, 0) : undefined}
									/>
									<div className='dashboard-content-area-card-chat-details-wrap'>
										<div className='dashboard-content-area-card-chat-name'>{booking.otherUserDetails?.name}</div>
									</div>
									<div className='dashboard-content-area-booking-status'>
										{getBookingStatusLabel(booking.status)}
									</div>
									<div className='dashboard-content-area-booking-cost-wrap'>
										<div className='dashboard-content-area-booking-cost'>
											<div className='dashboard-content-area-booking-cost-label'>Price</div>
											<div className='dashboard-content-area-booking-cost-value'>$ {(parseFloat(booking.price ? booking.price : '0') / 100).toFixed(2)}</div>
										</div>
										<div className='dashboard-content-area-booking-cost'>
										<div className='dashboard-content-area-booking-cost-label'>Tip</div>
											<div className='dashboard-content-area-booking-cost-value'>$ {booking.tip_price && booking.tip_payment_status == 'PAYMENT_COMPLETE' ? (parseFloat(booking.tip_price ? booking.tip_price : '0') / 100).toFixed(2) : '0.00'}</div>											
										</div>
										<div className='dashboard-content-area-booking-cost dashboard-content-area-booking-commision'>
											{/* {booking.status == InteractionStatus.COMPLETE ?
												<>$ {(parseFloat(booking.price ? booking.price : '0') * 0.0045).toFixed(2)}</>
												:
												<>$ 0.00</>
											} */}
											<div className='dashboard-content-area-booking-cost-label'>Commission</div>
											<div className='dashboard-content-area-booking-cost-value'>
												{booking.status == InteractionStatus.COMPLETE ?
													<>$ {(parseFloat(booking.price ? booking.price : '0') * 0.0045).toFixed(2)}</>
													:
													<>$ 0.00</>
												}
											</div>
										</div>
										<div className='dashboard-content-area-booking-cost dashboard-content-area-booking-total'>
											{/* {booking.status == InteractionStatus.COMPLETE ?
												<>$ {((parseFloat(booking.price ? booking.price : '0') * 0.0055)+(parseFloat(booking.tip_price ? booking.tip_price : '0') / 100)).toFixed(2)}</>
												:
												<>$ 0.00</>
											} */}
											{/* $ {((parseFloat(booking.price ? booking.price : '0') * 0.055)+(parseFloat(booking.tip_price ? booking.tip_price : '0') / 100)).toFixed(2)} */}
											<div className='dashboard-content-area-booking-cost-label'>Earning</div>
											<div className='dashboard-content-area-booking-cost-value'>
												{booking.status == InteractionStatus.COMPLETE ?
													<>$ {((parseFloat(booking.price ? booking.price : '0') * 0.0055)+(parseFloat(booking.tip_price && booking.tip_payment_status == 'PAYMENT_COMPLETE' ? booking.tip_price : '0') / 100)).toFixed(2)}</>
													:
													<>$ 0.00</>
												}
											</div>
										</div>
									</div>
								</a>
							)
						}
					</div>
				</div>
			</div>

			{/* <div className='dashboard-content-area-wide-card-wrap'>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-booking.svg`}
							alt='Booking symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Weekly Leaderboard</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{leaderboard.length === 0 ?
							<span>Weekly Leaderboard begining soon</span>
							:
							leaderboard.map((interactios: DashboardLeaderboard, index: number) => 
							<a 
								className='dashboard-content-area-card-chat-wrap'
								key={`chatItem${index}`}
								href={`chat?id=${interactios.bookingId}`}
							>
								<img
									className='dashboard-content-area-card-chat-img'
									alt='profile thumbnail'
									src={interactios.instructorImgSrc}
								/>
								<div className='dashboard-content-area-card-chat-details-wrap'>
									<div className='dashboard-content-area-card-chat-name'>{interactios.instructorName}</div>
								</div>
							</a>
						)}
					</div>
				</div>
			</div> */}
		</div>
	)
}

export default DashboardInstructorContentArea
